import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {ExportsComponent} from './exports/exports.component';

@NgModule({
  declarations: [
    ExportsComponent,
  ],
  imports: [
    CoreModule
  ],
  exports: [
    ExportsComponent,
  ],
})
export class ExportsModule {
}
